module.exports = __webpack_public_path__ + "DINNextLTPro-BoldCondensed.ttf?acd5a41d16e554a6707bd1950c1e2373";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldCondensed.ttf
// module id = 1390
// module chunks = 0